import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { Button } from './ui/button';

export const NoUpcomingEvents = () => (
  <div className="rounded-2xl border border-white/10 bg-white/5 px-6 py-12 sm:py-14 text-center" data-testid="no-upcoming-events">
    <CalendarDays className="h-8 w-8 text-amber-400 mx-auto mb-4" />
    <h3 className="text-xl sm:text-2xl font-bold text-white">New dates are being scheduled</h3>
    <p className="mt-3 text-slate-300 max-w-xl mx-auto leading-relaxed">
      There are no public events on the calendar right now. Explore our leadership and professional development programs for your team, available year-round.
    </p>
    <Button asChild className="mt-6 bg-gradient-to-r from-violet-600 to-amber-500 text-white">
      <Link to="/workshops" data-testid="no-events-workshops-link">
        Explore Workshops & Training <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </Button>
  </div>
);
